/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlock_More_Listings_Ai_FeatuInputs */

const en_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock more listings, AI features, custom domains, and`)
};

const es_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquea más anuncios, características de IA, dominios personalizados y`)
};

const fr_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquez plus d'annonces, de fonctionnalités IA, des domaines personnalisés, et`)
};

const de_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schalte mehr Inserate, KI-Funktionen, eigene Domains frei und`)
};

const ja_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さらに多くの出品枠、AI機能、カスタムドメインをロック解除し、`)
};

const zh_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁更多商品额度、AI 功能、自定义域名，并享受`)
};

const ar_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح المزيد من الإعلانات، وميزات الذكاء الاصطناعي، والنطاقات المخصصة، و`)
};

const id_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka lebih banyak listing, fitur AI, domain kustom, dan`)
};

const it_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca più annunci, funzioni IA, domini personalizzati e`)
};

const ru_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокируйте больше объявлений, функций ИИ, собственных доменов и`)
};

const pt_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueie mais anúncios, recursos de IA, domínios personalizados e`)
};

const ko_unlock_more_listings_ai_featu = /** @type {(inputs: Unlock_More_Listings_Ai_FeatuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 많은 상품 등록, AI 기능, 맞춤형 도메인 등을 잠금 해제하세요. 플랫폼 수수료:`)
};

/**
* | output |
* | --- |
* | "Unlock more listings, AI features, custom domains, and" |
*
* @param {Unlock_More_Listings_Ai_FeatuInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const unlock_more_listings_ai_featu = /** @type {((inputs?: Unlock_More_Listings_Ai_FeatuInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlock_More_Listings_Ai_FeatuInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlock_more_listings_ai_featu(inputs)
	if (locale === "es") return es_unlock_more_listings_ai_featu(inputs)
	if (locale === "fr") return fr_unlock_more_listings_ai_featu(inputs)
	if (locale === "de") return de_unlock_more_listings_ai_featu(inputs)
	if (locale === "ja") return ja_unlock_more_listings_ai_featu(inputs)
	if (locale === "zh") return zh_unlock_more_listings_ai_featu(inputs)
	if (locale === "ar") return ar_unlock_more_listings_ai_featu(inputs)
	if (locale === "id") return id_unlock_more_listings_ai_featu(inputs)
	if (locale === "it") return it_unlock_more_listings_ai_featu(inputs)
	if (locale === "ru") return ru_unlock_more_listings_ai_featu(inputs)
	if (locale === "pt") return pt_unlock_more_listings_ai_featu(inputs)
	return ko_unlock_more_listings_ai_featu(inputs)
});